<template>
  <div class="bl-register-wrap">
    <div class="bl-bg-head"></div>
    <div class="bl-register-box">
      <div class="flex">
        <div class="theme-color pointer font-size-13" @click="goPrev" style="right: auto; left: 20px;">
          <span class="iconfont iconfanhui"></span>{{ $t('login2s.back') }}
        </div>
        <div class="theme-color pointer font-size-13 .m-r-4" @click="registrationBackHome">
          <span class="backHomeS">{{ $t('logins.backHome') }}</span>
        </div>
      </div>

      <v-register-step :stepType='registerId' type="mobile"></v-register-step>
      <div class="v-register-comment">
        <div class="v-register-title v-register-flex">
          <div>{{ $t('login2s.resigerTitle') }}
            <!-- <span class="theme-color font-size-14 pointer" style="line-height: 14px" @click="changeResiger">{{type == 'email' ? $t("login2s.changeResiger[0]") : $t("login2s.changeResiger[1]")}}</span> -->
          </div>
          <div>
            <span class="font-size-14 m-r-4">{{$t('login2s.noAccount[1]')}}</span>
            <span class="theme-color font-size-14 pointer" style="line-height: 14px"
              @click="loginEvent">{{$t('login2s.register[1]')}}</span>
          </div>
        </div>
        <el-form action="" @keyup.enter.native="regLoginMess" label-position="top">
          <div class="v-pass-register-module p-b-24">
            <div class="font-size-14 label margin-b-8 margin-t-8" style="line-height: 20px">
              <span class="v-label-color">{{ $t('phone') }}</span>
            </div>
            <el-input :placeholder="$t('Please enter your moblie')" size="small" v-model.trim="inputVal.mobile"
              class="input-with-select" maxlength="11">
              <span slot="prepend">+86</span>
            </el-input>
            <v-codes :labelName="$t('code')" v-model="inputVal.smsCode" @callback="callback" :stop="disabled"
              :regText="inputVal.mobile"></v-codes>
            <!-- <v-input type="password" :labelName="$t('password')" v-model="inputVal.password"></v-input> -->
            <!-- <v-input type="password" :labelName="$t('confirmPassword')" :placeholder="$t('newPasswordAgain')" v-model="inputVal.repassword"></v-input> -->
          </div>
          <el-button type="primary" :loading='loading' class="v-big-btn" @click="regLoginMess">{{ $t('Next')
            }}</el-button>
        </el-form>
        <div class="v-register-flex font-size-12 p-b-24 p-t-24">
          <div>
            <span>{{ $t('You sign up and agree') }}</span>
            <span class="theme-color pointer"><router-link to="/agreement" target="_blank"> {{ $t('Privacy agreement')
                }}</router-link></span>
          </div>
          <TouristChat v-if="false" />
        </div>
      </div>
      <loginBottom></loginBottom>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import vCodes from '@/components/vCodes'
import { sendPhoneCode, validateMobile, login } from '@/api/index'
import { reg } from '@/utils/function'
import { setToken } from '@/utils/auth'
import vRegisterStep from '@/components/login/register_step.vue'
import TouristChat from '@/components/chat/TouristChat'
import loginBottom from '@/components/login/loginBottom.vue'

export default {
  name: 'vRegisterMobile',
  components: {
    vRegisterStep,
    TouristChat,
    loginBottom,
    vCodes
  },
  data() {
    return {
      times:300,
      show:true,
      slideCode:false,
      movedColor:"",
      registerId: 1,
      // 类型(手机号|邮箱)
      type: this.$route.params.type || 'mobile',
      // form 表单
      inputVal: {
        countryCode: '86',
        smsCode: '',
        mobile: '',
        password: '',
        repassword: ''
      },
      loading: false,
      disabled: false
    }
  },
  computed: {
    ...mapGetters(['language', 'loginAccount', 'subjectType'])
  },
  mounted() {
    window.PC.$RangersEventLoginAndRegister('mobileregistration_view')
    this.inputVal.mobile = this.loginAccount
  },
  methods: {
    goPrev() {
      this.loginSource({ path: '/login/person', replaceStatus: true })
    },
    // 验证字段
    regLoginMess() {
      let obj = this.inputVal
      let param = {}
      if (!obj.mobile) {
        this.$notify.error(this.$t('Please enter your mobile'))
        return false
      } else if (!reg.chinesePhone.test(obj.mobile)) {
        this.$notify.error(this.$t('Mobile is not correct'))
        return false
      } else if (!obj.smsCode) {
        this.$notify.error(this.$t('Please enter your verification code'))
        return false
      }
      window.PC.$RangersEventLoginAndRegister('mobileregistration_continue_click', {account: obj.mobile})
      param = JSON.parse(JSON.stringify(obj))
      this.$store.commit('SET_LOGIN_ACCOUNT', obj.mobile)
      this.submit(param)
    },
    // 注册
    async submit(params) {
      this.loading = true
      await login(params).then(async (res) => {
        const data = res.data.data;
        if (!data && res.headers.authorization) return
        if (!data.requiredSetPassword && data.requiredVisitorRegister) {
          // 完善个人信息
          await setToken(res.headers.authorization)
          await this.loginSuccess(this.subjectType, null, this.isPassLogin, this.inputVal)
        } else if (!data.requiredVisitorRegister) {
          this.$notify.error({
            title: this.$t('该手机号已注册')
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 发送验证码事件（邮箱/手机号）
    callback(res) {
        if (res.type !== 'sendCode') return
        validateMobile({
            mobile: this.inputVal.mobile
        }).then(res => {
            if (!res.data.data) return
            if (res.data.data.repeat) {
                this.$notify.error(this.$t('mobileRepeat'))
                this.disabled = true
            } else {
                // 发送手机号验证码
                sendPhoneCode({
                    mobile: this.inputVal.mobile
                }).then(res => {
                    setToken(res.headers.authorization)
                    this.$notify.success(this.$t('The verification code has been sent'))
                }).catch(() => {
                    this.disabled = true
                })
            }
        }).catch(() => {
            this.disabled = true
        }).finally(() => {
            this.disabled = false
        })
    },
    // 切换注册
    changeResiger() {
      if (this.type == 'email') {
        // 邮箱注册
        this.$router.push({path: "/l-register/mobile"})
      } else {
        // 手机号注册
        this.$router.push({path: "/l-register/email"})
      }
    },
    // 登录
    loginEvent() {
        this.$router.push({path: '/login/person',query: {t: 'mobile'}})
    }
  }
}
</script>
<style lang="stylus">
</style>
